import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NwmlsState } from './nwmls.reducer';

export const selectNwmlsDataState = createFeatureSelector<NwmlsState>('nwmls');

export const selectNwmlsList = createSelector(
  selectNwmlsDataState,
  (state: NwmlsState) => state.list
);

export const selectNwmlsPagination = createSelector(
  selectNwmlsDataState,
  (state: NwmlsState) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectNwmlsDataLoading = createSelector(
    selectNwmlsDataState,
    (state: NwmlsState) => state.loading
);

export const selectNwmlsDataError = createSelector(
    selectNwmlsDataState,
    (state: NwmlsState) => state.error
);

export const selectNwmlsDetail = createSelector(
  selectNwmlsDataState,
  (state: any) => state.detail
);

export const selectNwmlsDetailLoading = createSelector(
  selectNwmlsDataState,
    (state: any) => state.loading
);

export const selectNwmlsDetailError = createSelector(
    selectNwmlsDataState,
    (state: NwmlsState) => state.error
);
